import { Abstract } from "lamina/vanilla";
import customFrag from "../shaders/custom/frag.glsl"
import customVert from "../shaders/custom/vert.glsl"

class CustomLayer extends Abstract {

  // all
  static u_time = 0.0;

  // frag
  static u_colorA = "#2255ff";
  static u_colorB = "#ffd5ff";
  static u_cloudTint = "#988adb";
  static u_gain = 0.5;
  static u_lacunarity = 2.0;

  // vert
  static u_amp = 0.1;
  static u_detail = 0.1;
  static u_fbmOctaves = 2;

  static fragmentShader = customFrag;
  static vertexShader = customVert;

  constructor(props) {
    // You MUST call 'super' with the current constructor as the first argument.
    // Second argument is optional and provides non-uniform parameters like blend mode, name and visibility.
    super(CustomLayer, {
      name: "CustomLayer",
      ...props,
    });
  }
}

export default CustomLayer;
